import WebAPI from './WebAPI'
import {getTargetHistory, appendTargetHistory} from '@/api/index'

const API_FOR_WORKBENCH = process.env.API_ROOT

/**
 * Look at the Confluence API article for more information
 * https://audiencematters.atlassian.net/wiki/spaces/AM/pages/448135169/Revision+History
 */
class RevisionHistoryAPI extends WebAPI {
  constructor () {
    super({baseURL: API_FOR_WORKBENCH})
  }

  deleteBranch ({branchId}) {
    return this.__post({
      extensionURL: '/RevisionHistory/DeleteBranch',
      payload: {branch_id: branchId},
      addSession: true
    })
  }

  /**
   * This will forward the revision, from the move made here...
   * @param {RevisionHistoryBranch} branch
   */
  forwardRevision ({id, move, target_definition, label, target_data, audience, targetId}) {
    const payload = {branch_id: id, move, target_definition, label, target_data, audience}
    return appendTargetHistory(targetId, payload).then(r => r.data)
  }

  /**
   * This API will create a new branch off the branch id given here
   * @param {BranchOff}  branchOff
   */
  branchOffRevisionBranch ({branch_off_id, duplicate_up_to_move, label, audience, target_id}) {
    return this.__post({
      extensionURL: '/RevisionHistory/CreateNewBranch',
      payload: {branch_off_id, duplicate_up_to_move, label, audience, target_id},
      addSession: true
    })
  }

  /**
   * This will get the entire Revision History for the Target, all its Branches and thier histories
   * @param {target_id} target_id
   */
  getRevisionHistoryForTarget ({target_id}) {
    return getTargetHistory(target_id).then(r => r.data)
  }

  createMissingBranch ({id, display_name}) {
    return this.__post({
      extensionURL: '/RevisionHistory/CreateMissingRevisionHistory',
      payload: {id, display_name},
      addSession: true
    })
  }

}

export default new RevisionHistoryAPI()



// WEBPACK FOOTER //
// ./src/app/api/RevisionHistoryAPI.js